<template>
  <v-content style="background-color: #F8F8F8;margin-bottom: 15rem">
    <!-- Tab Desktop -->
    <v-layout v-if="$vuetify.breakpoint.smAndUp">
      <v-flex xs12>
        <v-card color="#F8F8F8" flat class="mt-6">
          <v-layout justify-space-between>
            <v-spacer />
            <v-flex
              xs2
              v-for="tab in tabs"
              :key="tab.id"
              :href="`#tab-${tab.id - 1}`"
              @click="$router.push(tab.link)"
              class="tab-menu"
            >
              <v-layout
                class="d-flex justify-center align-center"
                :class="$route.path === tab.link ? 'tab-active' : ''"
              >
                <v-flex shrink class="mr-3">
                  <v-icon
                    class="tab-icon"
                    style="font-size: 50px"
                    :color="$route.path === tab.link ? '#FD5246' : '#575757'"
                    >{{ tab.icon }}</v-icon
                  >
                </v-flex>
                <v-flex
                  class="tab-text"
                  shrink
                  :style="
                    $route.path === tab.link
                      ? { 'font-size': '20px', color: '#FD5246' }
                      : { 'font-size': '20px', color: '#575757' }
                  "
                >
                  {{ $t(tab.name) }}
                </v-flex>
              </v-layout>
            </v-flex>

            <v-spacer />
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Tab Desktop -->
    <v-layout v-else>
      <v-flex xs12>
        <v-layout class="text-center">
          <v-flex class="main-menu-hover main-menu-active">
            <v-icon large color="#FD5246">menu_book</v-icon>
            <div>
              {{ $t("portfolio") }}
            </div>
          </v-flex>
          <v-flex class="main-menu-hover" @click="getProfile">
            <v-icon large>account_circle</v-icon>
            <div>
              {{ $t("about") }}
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout class="justify-center">
      <v-flex class="xs12">
        <v-divider style="border: 0.5px solid #C4C4C4;"></v-divider>
      </v-flex>
    </v-layout>

    <v-layout class="justify-center">
      <v-flex class="xs11 sm10 md10 lg12" v-if="menuActive === 0">
        <!-- SlideGroup -->
        <v-layout class="justify-center px-2 mt-10">
          <v-flex xs12>
            <v-sheet
              :style="{ 'background-color': '#F8F8F8' }"
              class="mx-auto"
              max-width="100%"
            >
              <v-slide-group
                v-model="model"
                show-arrows
                center-active
                class="slide-group"
              >
                <v-slide-item
                  v-for="(category, i) in categorys"
                  :key="i"
                  v-slot:default="{ toggle }"
                >
                  <v-btn
                    v-if="category.portfolio_total !== 0"
                    @click="toggle"
                    class="mx-1 my-2"
                    :style="
                      selected_category_id === category.id
                        ? {
                            'background-color': checkBtnColor(category.id),
                            color: '#FFFFFF',
                            height: '40px',
                          }
                        : {
                            color: '#FFFFFF',
                            'background-color': '#9C9C9C',
                          }
                    "
                    height="40"
                    @click.native="onclickCategory(category.id)"
                  >
                    <v-img
                      lazy-src=""
                      :width="category.id == 0 ? '20' : '35'"
                      :src="checkIcon(category.name_en)"
                    ></v-img>
                    <span class="ml-4">{{
                      switchLanguage === "th"
                        ? category.name_th
                        : category.name_en
                    }}</span>
                    <span class="ml-3" style="color: #fff">
                      {{ category.portfolio_total }}
                    </span>
                  </v-btn>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </v-flex>
        </v-layout>

        <!-- All Portfolio -->
        <v-layout class="justify-center mb-8">
          <v-flex xs12>
            <!-- Sub Slide Group -->
            <div v-if="$vuetify.breakpoint.mdAndUp">
              <v-layout v-show="categoryID != 0" class="justify-center px-2">
                <v-flex xs12>
                  <v-layout wrap class="mt-3" style="background-color: #F8F8F8">
                    <v-flex
                      class="shrink on-hover-cate mr-3 mb-2"
                      @click="onClickSubCate(0)"
                      :class="subcategory_id === 0 ? 'active-category' : ''"
                    >
                      <v-btn
                        v-if="subcategory_id === 0"
                        width="100%"
                        height="100%"
                        outlined
                        large
                        color="#FD5246"
                      >
                        <span>{{ $t("all") }}</span>
                      </v-btn>
                      <span v-if="subcategory_id !== 0">All</span>
                      <v-divider
                        class="ml-2"
                        v-if="subcategory_id !== 0"
                        vertical
                      ></v-divider>
                    </v-flex>
                    <div
                      class="d-flex"
                      v-for="(subCate, i) in subCategoryLists"
                      :key="i"
                    >
                      <v-flex
                        shrink
                        class="text-center on-hover-cate d-flex align-center mr-3 mb-2"
                        @click="
                          subCate.subcategory
                            ? onClickSubCate(subCate.subcategory.id)
                            : ''
                        "
                      >
                        <div
                          class="d-flex"
                          v-if="subCate.subcategory && subCate.total > 0"
                        >
                          <v-btn
                            v-if="subcategory_id === subCate.subcategory.id"
                            width="100%"
                            height="100%"
                            outlined
                            large
                            color="#FD5246"
                          >
                            <span>
                              {{
                                switchLanguage === "th"
                                  ? subCate.subcategory.name_th
                                  : subCate.subcategory.name_en
                              }}
                              ({{ subCate.total }})
                            </span>
                          </v-btn>
                          <span v-else>
                            {{
                              switchLanguage === "th"
                                ? subCate.subcategory.name_th
                                : subCate.subcategory.name_en
                            }}
                            ({{ subCate.total }})
                          </span>
                          <v-divider
                            class="ml-2"
                            v-if="subcategory_id !== subCate.subcategory.id"
                            vertical
                          ></v-divider>
                        </div>
                      </v-flex>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <div v-else>
              <v-layout class="px-3" v-if="selected_category_id != 0">
                <v-flex v-if="subCateLists.length > 0">
                  <v-autocomplete
                    hide-details
                    placeholder="หมวดหมู่ย่อย"
                    color="#FD5246"
                    outlined
                    dense
                    flat
                    menu-props="offset-y"
                    :items="subCateLists"
                    item-value="id"
                    :item-text="$i18n.locale === 'th' ? 'name_th' : 'name_en'"
                    @change="onClickSubCate"
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ $i18n.locale === "th" ? item.name_th : item.name_en }}
                      ({{ item.total }})
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </div>

            <v-layout
              class="px-12 mt-12"
              v-if="portfolios.data === []"
              style="padding-bottom: 29rem"
            >
              <v-flex class="text-center">
                <span style="color: #5d5d5d">{{ $t("status-not-fount") }}</span>
              </v-flex>
            </v-layout>

            <v-container fluid mt-8>
              <v-card flat color="#F8F8F8" min-height="300px">
                <v-row>
                  <!-- @click="viewPortDetail(item)" -->
                  <v-col
                    v-for="(item, index) in portfolios.data"
                    :key="index"
                    :cols="
                      $vuetify.breakpoint.lgAndUp
                        ? 2
                        : '' || $vuetify.breakpoint.md
                        ? 3
                        : '' || $vuetify.breakpoint.sm
                        ? 6
                        : '' || $vuetify.breakpoint.xs
                        ? 12
                        : ''
                    "
                  >
                    <CardContentAction
                      :viewPortDetail="viewPortDetail"
                      :onDelete="onDelete"
                      font-lg="14"
                      font-md="14"
                      font-sm="14"
                      :item="item"
                      :hoverTitle="item.project_title"
                      width="100"
                      height="100%"
                      :image-cover="item.cover_img_path"
                      :title="item.project_title"
                      :by="item.profile"
                      :image-profile="
                        item.profile ? checkImage(item.profile.mem_info) : ''
                      "
                    ></CardContentAction>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex class="paginate">
            <v-pagination
              color="#FD5246"
              light
              v-model="paginate.current_page"
              :length="paginate.last_page"
              :total-visible="7"
              @input="getPortfolioByMemberIdCategoryId"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </v-content>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { domain, imgPath } from "../../services/Constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import CardContent from "../../components/card_content/CardContent";
import CardContentAction from "../../components/card_content/CardContentAction.vue";

export default {
  name: "ProfilePortfolio",
  components: {
    Loading,
    CardContent,
    CardContentAction,
  },
  data: () => ({
    selected_category_id: 0,
    model: null,
    isLoading: false,
    fullPage: true,
    imgPath: imgPath,
    url: domain,
    portfolios: [],
    portfolios_lenght: null,
    tab: null,
    tabs: null,
    isActive: false,
    isActiveMainMenu: false,
    item: 0,
    data_facebook: [],
    menuActive: 0,
    active_tab: "tab-2",
    tabs: [
      {
        id: 1,
        name: "portfolio_profile",
        icon: "menu_book",
        link: "/profile-portfolio",
      },
      {
        id: 2,
        name: "about",
        icon: "account_circle",
        link: "/profile-about",
      },
    ],
    tab: 1,
    categorys: [
      {
        id: 0,
        name_th: "รวม",
        name_en: "All",
        icon: "subject",
        portfolio_total: "",
      },
    ],
    subCateLists: [],
  }),
  computed: {
    ...mapState({
      profile: (state) => {
        return state.auth.users;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
      paginate: (state) => {
        return state.portfolio.portfolio_design.paginate;
      },
      categoryID: (state) => {
        return state.portfolio.portfolio_design.categoryID;
      },
      subcategory_id: (state) => {
        return state.portfolio.portfolio_design.subcategory_id;
      },
      subCategoryLists: (state) => {
        return state.portfolio.portfolio_design.subCategoryLists;
      },
    }),
  },
  // async mounted() {
  //     await this.loadFacebookSDK(document, "script", "facebook-jssdk");
  //     await this.initFacebook();
  // },
  async created() {
    console.log(this.$route.path);
    this.isLoading = true;
    await Promise.all([
      this.getCategoryByDesign(),
      this.clearPaginate(1),
      this.getProfilePortfolio(1),
    ]);
    this.isLoading = false;

    this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
  },
  watch: {
    subCategoryLists: function(val) {
      this.subCateLists = [];
      for (var key of Object.keys(this.subCategoryLists)) {
        if (this.subCategoryLists[key].subcategory) {
          this.subCateLists.push({
            category_id: this.subCategoryLists[key].subcategory.category_id,
            id: this.subCategoryLists[key].subcategory.id,
            name_en: this.subCategoryLists[key].subcategory.name_en,
            name_th: this.subCategoryLists[key].subcategory.name_th,
            total: this.subCategoryLists[key].total,
          });
        }
      }
    },
  },
  methods: {
    ...mapActions("portfolio", ["onDeletePortfolio"]),
    onDelete(id) {
      this.$swal({
        title: this.$t("confirm-delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#FD5246",
        cancelButtonColor: "#525252",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("cancle"),
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          ๆ;
          this.onDeletePortfolio(id)
            .then((res) => {
              if (res.status === 200) {
                this.$swal({
                  icon: "success",
                  title: this.$t("delect-portfolio-success"),
                  confirmButtonColor: "#FD5246",
                  confirmButtonText: "ตกลง",
                });
                this.isLoading = false;
                this.getProfilePortfolio(1);
              }
            })
            .catch((e) => {
              this.$swal({
                icon: "error",
                title: "เกิดข้อผิดพลาด",
                text: "ลบข้อมูลไม่สำเร็จ",
                confirmButtonColor: "#FD5246",
                confirmButtonText: "ตกลง",
              });
              this.isLoading = false;
            });
        }
      });
    },
    clearPaginate(page) {
      return this.$store.dispatch("portfolio/clearPaginate", page);
    },
    onActive(val) {
      this.isActive = val;
    },
    getProfilePortfolio(page) {
      return this.$store
        .dispatch("portfolio/getProfilePortfolio", {
          id: this.profile.profile_id,
          page: page,
        })
        .then((res) => {
          this.portfolios = res;
          this.portfolios_lenght = res.data.length;
        });
    },
    getCategoryByDesign() {
      return axios({
        url: `${domain}api/get-category-design?profile_id=${this.profile.profile_id}`,
        method: "GET",
      }).then((res) => {
        this.portfolio_amount = res.data.count_port_all;
        this.categorys[0].portfolio_total = res.data.count_port_all;
        res.data.categories_list.forEach((data) => {
          this.categorys.push({
            id: data.id,
            name_th: data.name_th,
            name_en: data.name_en,
            icon: data.icon,
            portfolio_total: data.portfolio_total,
          });
        });
      });
    },
    getPortfolioByMemberIdCategoryId(page) {
      this.isLoading = true;
      return this.$store
        .dispatch("portfolio/getPortfolioDesign", {
          page: page,
          profile_id: this.profile.profile_id,
          category_id: this.categoryID,
          subcategory_id: 0,
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    checkApprove(val) {
      if (val === 0) {
        return "ไม่อนุมัติ";
      } else if (val === 1) {
        return "อนุมัติ";
      } else {
        return "รอการอนุมัติ";
      }
    },
    viewPortDetail(port) {
      // let slug =
      //   port.profile.mem_info && port.profile.mem_info.domain_name
      //     ? port.profile.mem_info.domain_name
      //     : port.profile.profile_id;
      // this.$router.push({
      //   path: `/detail-portfolio/${slug}`,
      //   query: { id: port.portfolio_id, pfid: port.profile.profile_id },
      // });
      let domain_slug =
        port.profile.mem_info && port.profile.mem_info.domain_name
          ? port.profile.mem_info.domain_name
          : port.profile.profile_id;
      this.$router.push({
        path: `/profile/${domain_slug}/${port.portfolio_id}`,
      });
    },
    onclickCategory(id) {
      this.selected_category_id = id;
      this.isLoading = true;
      this.$store
        .dispatch("portfolio/getPortfolioDesign", {
          page: this.paginate.current_page,
          profile_id: this.profile.profile_id,
          category_id: id,
          subcategory_id: 0,
        })
        .then((res) => {
          this.isLoading = false;
        });
    },
    getProfile() {
      this.$store.dispatch("profile/onGetProfileInfo", this.profile.profile_id);
      this.$router.push("/profile-about");
    },
    onClickSubCate(id) {
      this.isLoading = true;
      this.$store
        .dispatch("portfolio/getPortfolioDesign", {
          page: this.paginate.current_page,
          profile_id: this.profile.profile_id,
          category_id: this.categoryID,
          subcategory_id: id,
        })
        .then((res) => {
          this.isLoading = false;
        });
    },
    checkIcon(iconName) {
      switch (iconName) {
        case "Design":
          return require("../../assets/icons/whiteIcon/การออกแบบ@2x.png");
        case "Architecture":
          return require("../../assets/icons/whiteIcon/สถาปัตยกรรม@2x.png");
        case "Fashion":
          return require("../../assets/icons/whiteIcon/แฟชั่น@2x.png");
        case "Craft":
          return require("../../assets/icons/whiteIcon/งานฝีมือ@2x.png");
        case "Advertising":
          return require("../../assets/icons/whiteIcon/การโฆษณา@2x.png");
        case "Visual Arts":
          return require("../../assets/icons/whiteIcon/ทัศนศิลป์@2x.png");
        case "Food":
          return require("../../assets/icons/whiteIcon/อาหารไทย@2x.png");
        case "Cultural and Heritage Tourism":
          return require("../../assets/icons/whiteIcon/การท่องเที่ยวเชิงวัฒนธรรม@2x.png");
        case "Film":
          return require("../../assets/icons/whiteIcon/ภาพยนต์@2x.png");
        case "Publishing":
          return require("../../assets/icons/whiteIcon/การพิมพ์@2x.png");
        case "Software":
          return require("../../assets/icons/whiteIcon/ซอฟแวร์@2x.png");
        case "Music":
          return require("../../assets/icons/whiteIcon/ดนตรี@2x.png");
        case "Performing Arts":
          return require("../../assets/icons/whiteIcon/ศิลปะการแสดง@2x.png");
        case "Broadcasting":
          return require("../../assets/icons/whiteIcon/การแพร่ภาพและกระจายเสียง@2x.png");
        case "Thai Traditional Medicine":
          return require("../../assets/icons/whiteIcon/การแพทย์แผนไทย@2x.png");
        default:
          return require("../../assets/icons/whiteIcon/ทั้งหมด@2x.png");
      }
    },
    checkBtnColor(cateId) {
      switch (cateId) {
        case "0":
          return "#ef3e2e";
        case "10":
          return "#74bf92";
        case "11":
          return "#ac9277";
        case "12":
          return "#c98074";
        case "1":
          return "#957722";
        case "9":
          return "#e19705";
        case "4":
          return "#4cc2d2";
        case "13":
          return "#e47645";
        case "115":
          return "#8a233d";
        case "5":
          return "#cd4646";
        case "7":
          return "#92b4cb";
        case "8":
          return "#9f939a";
        case "2":
          return "#733c90";
        case "3":
          return "#684c41";
        case "6":
          return "#3b5fa6";
        case "14":
          return "#28645e";
        default:
          return "#ef3e2e";
      }
    },
    checkImage(val) {
      if (val) {
        if (val.avatar) {
          return val.avatar;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    onHandleMenu(val) {
      switch (val) {
        case "portfolio":
          this.menuActive = 0;
          this.data_facebook = [];
          this.getProfilePortfolio(1);
          break;
        // case 'facebook' :
        //     this.menuActive = 1;
        //     let _this = this;
        // window.FB.login(function (response) {
        //     if (response.authResponse) {
        //         window.FB.api('/me', 'GET', {"fields": "id,photos{images,name,width,height}"}, function (response) {
        //             _this.data_facebook = response.photos.data;
        //         });

        //     } else {
        //         _this.isLoading = false;
        //     }
        // })
        //     this.isLoading = false;
        //     return false;
        //     break;
      }
    },
    // async initFacebook() {
    //     window.fbAsyncInit = function () {
    //         window.FB.init({
    //             appId: "313137639786162", //You will need to change this
    //             // appId: "598427080789805", //You will need to change this
    //             cookie: true, // This is important, it's not enabled by default
    //             version: "v7.0"
    //         });
    //     };
    // },
    // async loadFacebookSDK(d, s, id) {
    //     var js,
    //         fjs = d.getElementsByTagName(s)[0];
    //     if (d.getElementById(id)) {
    //         return;
    //     }
    //     js = d.createElement(s);
    //     js.id = id;
    //     js.src = "https://connect.facebook.net/en_US/sdk.js";
    //     fjs.parentNode.insertBefore(js, fjs);
    // },
  },
};
</script>

<style lang="scss">
.tab-menu:hover {
  // border-bottom: 2px solid #fd5246;
  cursor: pointer;
  color: #fd5246;
  .tab-text {
    color: #fd5246 !important;
  }
  .tab-icon {
    color: #fd5246 !important;
  }
}
.hover-tab:hover {
  color: #fd5246;
  cursor: pointer;
}
.side-menu-portfolio {
  .v-list {
    padding: 0;
  }
}
.tabs-top {
  width: 150px !important;
}

.theme--light.v-tabs > .v-tabs-bar .v-tab--disabled,
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon {
  color: #000000 !important;
}
.side-menu {
  box-shadow: -10px 0.5px 0.5px #c4c4c4;
}
/*top menu*/
.theme--light.v-tabs .v-tab--active:before,
.theme--light.v-tabs .v-tab--active:hover:before,
.theme--light.v-tabs .v-tab:focus:before {
  opacity: 0 !important;
}
.theme--light.v-tabs .v-tab:hover:before {
  opacity: 0 !important;
}
.v-tab--active.v-tab:not(:focus):before {
  opacity: 0;
}
.v-tabs-slider {
  background-color: currentColor;
  height: 100%;
  width: 100%;
}
.active-v-list-item-before {
  box-shadow: -2px 0.25px 0.25px;
}
.active-v-list-item-after {
  box-shadow: -10px 0px 0px;
}
.menu-hover:hover {
  background-color: rgba(253, 82, 70, 0.25);
  cursor: pointer;
  color: #fd5246;
}
.tab-active {
  color: #fd5246;
  border-bottom: 5px solid #fd5246;
}
.main-menu-hover:hover {
  cursor: pointer;
}
.main-menu-active {
  color: #fd5246;
  border-bottom: 5px solid #fd5246;
}
.menu-active {
  color: #fd5246;
}
</style>
